module.exports = __webpack_public_path__ + "static/media/3_english.33192cf2.png";